import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { url_79 } from "../../../../../../../custom_utilities/api_services";
import useAuthUtils from "../../../../../../../hooks/auth/useAuthUtils";
import usePyqRedux from "./usePyqRedux";

export const useGetPyqPaperList = () => {
  const { startLoading, finishLoading } = useAuthUtils();
  const { pyqCurrentYear, pyqMainCurrentTab, pyqSubCurrentTab } = usePyqRedux();

  const fetchPyqPaperList = async () => {
    try {
      startLoading();
      const response = await axios.post(url_79, {
        year: pyqCurrentYear,
        category_id: pyqMainCurrentTab?.category_id || "",
      });

      if (response.data.status === 200) {
        return response?.data?.data;
      }

      return [];
    } catch (error) {
      console.log(error);
      return [];
    } finally {
      finishLoading();
    }
  };

  return useQuery({
    queryKey: [
      "pyq-paper-list",
      pyqCurrentYear,
      pyqMainCurrentTab,
      pyqSubCurrentTab,
    ],
    queryFn: fetchPyqPaperList,
    enabled: !!pyqCurrentYear, // Only run if year is provided
  });
};
